import { render } from "./PregnancyInfoAboutMom.vue?vue&type=template&id=568ee096&scoped=true"
import script from "./PregnancyInfoAboutMom.vue?vue&type=script&lang=js"
export * from "./PregnancyInfoAboutMom.vue?vue&type=script&lang=js"

import "./PregnancyInfoAboutMom.vue?vue&type=style&index=0&id=568ee096&scoped=true&lang=scss"
import "./PregnancyInfoAboutMom.vue?vue&type=style&index=1&id=568ee096&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568ee096"]])

export default __exports__